export const githubUsername = "KamilJustynski";
